// @flow
import { type Receipt } from '@tectonics/prs/receipts';
import { type IncomingPayment, getFinalReceipt, getReceipts, getStatus } from '@tectonics/prs/incoming-payment';

export function decideReceipt(incomingPayment: IncomingPayment): Receipt {
  if (!['CA', 'OP'].includes(getStatus(incomingPayment)))
    return getFinalReceipt(incomingPayment);

  return getReceipts(incomingPayment).main;
}
